export const studentValidation = {
  firstName: {
    required: 'First name is required',
    pattern: {
      value: /^[a-zA-Z\s'-]+$/,
      message: 'Only letters, spaces, hyphens, and apostrophes allowed'
    },
    maxLength: {
      value: 50,
      message: 'Cannot exceed 50 characters'
    }
  },
  lastName: {
    required: 'Last name is required',
    pattern: {
      value: /^[a-zA-Z\s'-]+$/,
      message: 'Only letters, spaces, hyphens, and apostrophes allowed'
    },
    maxLength: {
      value: 50,
      message: 'Cannot exceed 50 characters'
    }
  },
  email: {
    required: 'Email is required',
    pattern: {
      value: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
      message: 'Invalid email format'
    },
    maxLength: {
      value: 255,
      message: 'Cannot exceed 255 characters'
    }
  },
  phoneNumber: {
    required: 'Phone number is required',
    minLength: {
      value: 7,
      message: 'Must have at least 7 digits'
    },
    maxLength: {
      value: 15,
      message: 'Cannot exceed 15 digits'
    }
  }
};